module.exports = __webpack_public_path__ + "img/thumb-chinese-kip-met-tomatensaus.32848272.jpeg";